import { Union } from 'ts-toolbelt';

import goToDiPath from 'utils/goToDiPath';

export default (nextStepPath: Union.Nullable<string>) => {
  if (nextStepPath) {
    window.location.assign(`${process.env.REACT_APP_PG_MONOLITH_HOST}${nextStepPath}`);
  } else {
    goToDiPath('comparison');
  }
};
